import React, { Component, useEffect } from 'react';
import { Link, useNavigate } from "react-router-dom";
import dogpic from './images/logo1.jpg'
import 'bootstrap/dist/css/bootstrap.css';
import './css_files/breed.css';
import { url } from "../weburl"
    ;
import axios from 'axios'
import { withRouter } from './pedigree_cards';
import { useState } from 'react';
import { dogUrlGenerator } from '../../util.js/dogUrlGenerator';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import SearchSvg from './images/search-icon.svg'
import DogCard from './dog_card';
import DogCardList from './dog-card-list';
import Popup from 'reactjs-popup';
import { Button } from '@mui/material';

export const RegistrationSearchPopup = (props) => {
    const [dogs, setDogs] = useState([])
    const [search_input, setSearchInput] = useState('')
    const [search_dogs, setSearchDogs] = useState({})
    const [closeModal, setCloseModal] = useState(false)
    const navigate = useNavigate()
    useEffect(() => {
        axios
            .get(`${url}api/dogs/search/${search_input}`)
            .then((res) => {
                setSearchDogs(res.data)
                // console.log(search_dogs)
            }
            )
            .catch((err) => console.log(err))
    }, [search_input])

    const onInputChange = (e) => {
        setSearchInput(e.target.value)

    }



    const displayResults = (close) => {
        if (search_dogs) {
            return Object.keys(search_dogs).map((item) => {
                console.log(console.log(search_dogs[item]['name']))

                return <div className='col-md-4 brand-hover-transform brand-yellow-box-shadow'>
                    <button className='btn w-100  text-dark' name={props.name}
                        value={search_dogs[item]['id']}
                        onClick={e => {
                            props.handleSireSelect(props.name, search_dogs[item]['id'], search_dogs[item]['name'])
                            setSearchInput(search_dogs[item]['name'])
                            setSearchDogs({})
                            close()
                            console.log('search input', search_input)
                        }}
                    >         <div className='row align-items-center justify-content-start py-0'>

                            <div className='col-md-4'>
                                {search_dogs[item]['public_id']
                                    ?
                                    <img
                                        src={`https://res.cloudinary.com/daurieb51/image/upload/v1642082142/${search_dogs[item]['public_id']}.png`}
                                        className='rounded w-100 ' alt="" />
                                    :

                                    <img
                                        src={dogpic}
                                        className='rounded w-100 ' alt="" />
                                }

                            </div>
                            <div className='col-md-7 font-weight-bold py-5 py-md-0 text-white text-wrap'> {search_dogs[item]['name']}</div>
                        </div>

                    </button>
                </div>
            })
        }

    }
    return (

        <Popup
            trigger={

                  <div>
                        <Button onClick={(e) => e.preventDefault()} type='none' className='' sx={{color: "#ba8108"}}>
                            {props.buttonTitle}</Button >
                  </div>
                }
            contentStyle={{ width: '80%', overflowY: 'scroll', height: '85%', backgroundColor: "#28261f" }}
            position="right"
            modal
            nested
            closeOnDocumentClick
        >{close => (
            <div className='container-fluid pt-3'>
                <div className='row align-items-center justify-content-center pb-2'>
                    <div className="col-md-10">
                        <input type='search' class='search_input py-2 px-2'
                            name={props.name} value={search_input}
                            onChange={(e) => onInputChange(e)}
                            placeholder='Search for dog'></input>
                    </div >


                </div>
                {/* {closeModal && close()} */}
                <div className='row align-items-center justify-content-center '>
                    {displayResults(close)}

                </div>

            </div>
        )

            }

        </Popup>




    )
}

